import { createAuthClient, type AuthClient } from '@entx/auth/client'

/**
 * Better-Auth client for Self-Service Portal
 *
 * Provides React hooks and methods for authentication in the browser.
 * The baseURL is automatically set to the current origin in the browser,
 * or falls back to localhost:3005 for SSR.
 */
const baseURL = typeof window !== 'undefined' ? window.location.origin : `http://localhost:${process.env.PORT || 3005}`

export const authClient: AuthClient = createAuthClient({
    baseURL,
    // TODO: Replace with actual app URLs for cross-app sign-out
    allAppURLs: [baseURL], // Temporary: only sign out from current app
})

export const signIn: AuthClient['signIn'] = authClient.signIn
export const signUp: AuthClient['signUp'] = authClient.signUp
export const signOut: AuthClient['signOut'] = authClient.signOut
export const signOutAll: AuthClient['signOutAll'] = authClient.signOutAll
export const useSession: AuthClient['useSession'] = authClient.useSession
